// Patterns that strongly suggest protected health information in a contact
// form message. Not exhaustive (a patient's name can't be told apart from any
// other name), so this backs up, rather than replaces, the warning copy and
// confirmation checkbox. Keep in sync with server/utils/phi.js, which
// enforces the same rule server-side.
const PHI_PATTERNS = [
  /\b\d{3}-\d{2}-\d{4}\b/, // SSN
  /\b(d\.?o\.?b\.?|date\s+of\s+birth|birth\s*date|mrn|medical\s+record\s*(number|no\.?|#)?|ssn|social\s+security)\b/i,
  /\b\d{1,2}[/.-]\d{1,2}[/.-](19\d{2}|20(0\d|1[0-5]))\b/, // dates with a birth-year (pre-2016) year
  /\b(accession|specimen\s*(id|no\.?|number|#)|case\s*(no\.?|number|#))/i,
  /\b(patient|pt)'?s?\s+(name|named|dob)\b/i
];

export const PHI_MESSAGE =
  'Your message looks like it may include patient information (such as a date of birth, record number, or specimen ID). Please remove it. For patient-specific questions, call (561) 638-7577 or use the provider portal.';

export const looksLikePHI = (...fields) => fields.some((text) => PHI_PATTERNS.some((re) => re.test(text || '')));
